module.exports = __webpack_public_path__ + "static/media/arrowRigth.3b0bd9f0.webp";